import { Parameter } from "domain/entities/parameter";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface TripOriginState {
  tripOrigin: Parameter[];
  setTripOrigin: (newTripOrigin: Parameter[] | undefined) => void;
}

export const useTripOriginStore = create<TripOriginState>()(
  devtools(
    (set) => ({
      tripOrigin: [],
      setTripOrigin: (newTripOrigin) =>
        set(() => ({
          tripOrigin: newTripOrigin ? [...newTripOrigin] : [],
        })),
    }),
    { name: "TripOriginStore" }
  )
);
